<template>
  <legal-page
    title="Términos y Condiciones"
    :intro="`Al acceder y utilizar el portal de ${business.name} para consultar tu cuenta y realizar pagos, aceptas los presentes Términos y Condiciones. Si no estás de acuerdo, por favor no utilices el portal.`"
  >
    <div class="legal-sections">
      <legal-section
        step="01"
        title="Objeto"
        icon="TargetIcon"
        variant="info"
      >
        <p>
          Este portal permite a los clientes de
          {{ business.name }} consultar el estado de su contrato y
          pagar sus facturas de servicios de telecomunicaciones
          (Internet, televisión por cable y telefonía) mediante
          tarjetas de crédito o débito.
        </p>
      </legal-section>

      <legal-section
        step="02"
        title="Pagos"
        icon="CreditCardIcon"
        variant="success"
      >
        <p>
          Los pagos se procesan de forma segura a través de la
          pasarela AZUL. El monto a pagar corresponde al balance
          pendiente del contrato, expresado en Pesos Dominicanos
          (RD$/DOP). Al confirmar el pago, autorizas el cargo
          correspondiente a tu tarjeta.
        </p>
      </legal-section>

      <legal-section
        step="03"
        title="Responsabilidades del usuario"
        icon="UserCheckIcon"
        variant="warning"
      >
        <p>
          Eres responsable de la veracidad de los datos suministrados
          y del uso de tus credenciales de acceso.
          {{ business.name }} no almacena los datos completos de tu
          tarjeta; estos son gestionados directamente por el proveedor
          de pagos.
        </p>
      </legal-section>

      <legal-section
        step="04"
        title="Modificaciones"
        icon="EditIcon"
      >
        <p>
          {{ business.name }} podrá modificar estos términos en
          cualquier momento. Los cambios entran en vigor desde su
          publicación en este portal.
        </p>
      </legal-section>

      <legal-section
        step="05"
        title="Ley aplicable"
        icon="BookOpenIcon"
      >
        <p>
          Estos Términos y Condiciones se rigen por las leyes de
          {{ business.country }}. Para cualquier consulta escríbenos a
          <a :href="`mailto:${business.email}`">{{
            business.email
          }}</a>.
        </p>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection },
  data() {
    return { business }
  },
}
</script>
